export const DEFAULT_DELAY_TIMEOUT_IN_MS = 750;
